export default __webpack_public_path__ + "static/media/image2pro3.e2390689.jpeg";